import { Link, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { careerData } from './CareerData'; // Create this next
import { Helmet } from 'react-helmet-async';
import Icon1 from '../../assets/img/shape/shape-3.png';
import { FaCircle } from "react-icons/fa";
import CareerSection from '../../components/Careers/CareerSection';

function CareerDetails() {
  const { roleId } = useParams();
  const [role, setRole] = useState(null);

  useEffect(() => {
    const roleDetails = careerData.find(r => r.slug === roleId);
    setRole(roleDetails);
  }, [roleId]);

  if (!role) return <div className='container'>Loading...</div>;

  return (
    <>
        <Helmet>
            <title>Career Details | Cardplot</title>
        </Helmet>
        <section className="career__details">
            <section className='breadcrumb__section bg-overlay'>
                <div className="container">
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className="breadcrumb__title__head">
                                <ol className="breadcrumb">
                                    <li className="active"><img src={Icon1} style={{ width: '25px', height: '25px' }} alt="" /></li>
                                </ol>
                                <h2 className='breadcrumb__title'> CAREERS </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="breadcrumb__text">
                                <h3 className='breadcrumb__text__head heading'>{role.title}</h3>
                                <p className='breadcrumb__text__content'>{role.summary}</p>
                            </div>
                            {role.status === 'open' && (
                                <div className='d-flex gap-3 justify-content-center align-items-center' style={{ paddingTop: '40px' }}>
                                    <Link to='' className='btn btn__primary'>Apply</Link>
                                    <Link to='' className='btn btn__outline_primary text__dark'>Shortlist</Link>
                                </div>
                            )}

                            <div className={`status__role mt-3 ${role.status === 'open' ? 'status__open' : 'status__closed'}`}>
                                <div className="d-flex gap-3 justify-content-center align-items-center">
                                    <div className=""><FaCircle color={role.status === 'open' ? '#83BF4F' : '#ED4C5C'} size={25} /></div>
                                    <h4 className='mb-0'>{role.status === 'open' ? 'Open' : 'Closed'}</h4>
                                    {role.status === 'open' && (
                                        <div className="posting__duration d-flex flex-column justify-content-center align-items-center p-2 bg-white rounded">
                                            <p className='posting__duration__text'>Posted - { new Date(role.posted).toLocaleString("default", { day: "numeric", month: "short", year: "numeric",}) }</p>
                                            <p className='posting__duration__text'>Closes - { new Date(role.deadline).toLocaleString("default", { month: "short", day: "numeric", year: "numeric",}) }</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="container my-5">

                {role.sections.map((section, index) => (
                    <div key={index} className="section mb-6" style={{ maxWidth: '1000px', margin: '0 auto' }}>
                        <h4 className="font-semibold mb-2">{section.title}</h4>
                        <div className="section-content mb-5"
                            dangerouslySetInnerHTML={{ __html: section.content }}
                        />
                    </div>
                ))}

                <p style={{ maxWidth: '1000px', margin: '0 auto' }}>Join Cardplot and help us connect Africa to the world—one payment at a time!</p>
            </div>

            <section><CareerSection /></section>
        </section>
    </>
  );
}

export default CareerDetails;
